/** Anzeige-Format eines gelösten Plans: Tagesname → Zeit → member_id bzw. Name. */
export type DisplaySchedule = Record<string, Record<string, string>>;

interface StudentWithMemberId {
  member_id?: string | number | null;
  name?: string | null;
}

export function convertMemberIdsToNames(
  schedule: DisplaySchedule | null | undefined,
  studentsList: readonly StudentWithMemberId[] | null | undefined,
): DisplaySchedule {
  const safeSchedule = schedule && typeof schedule === "object" ? schedule : {};
  const safeStudentsList = Array.isArray(studentsList) ? studentsList : [];
  const memberMap = new Map<string, string | null | undefined>();
  const duplicateMemberIds = new Set<string>();

  safeStudentsList.forEach((student) => {
    if (!student || student.member_id === undefined || student.member_id === null) {
      return;
    }

    const memberKey = String(student.member_id);
    if (memberMap.has(memberKey)) {
      duplicateMemberIds.add(memberKey);
      return;
    }

    memberMap.set(memberKey, student.name);
  });

  if (process.env.NODE_ENV === "development" && duplicateMemberIds.size > 0) {
    console.warn(
      "[convertMemberIdsToNames] Duplicate member_id values detected. Using first occurrence for:",
      Array.from(duplicateMemberIds)
    );
  }

  const scheduleWithNames: DisplaySchedule = {};

  Object.entries(safeSchedule).forEach(([day, daySchedule]) => {
    scheduleWithNames[day] = {};
    if (!daySchedule || typeof daySchedule !== "object") {
      return;
    }

    Object.entries(daySchedule).forEach(([time, memberId]) => {
      if (!memberId || memberId === "") {
        return;
      }

      const memberKey = String(memberId);
      scheduleWithNames[day][time] = memberMap.get(memberKey) || 'Entfernter Schüler';
    });
  });

  return scheduleWithNames;
}
